//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mobileTab from '~/components/common/mobileTab.vue'
import barCharts from '~/components/home/historicaldetails/barCharts.vue'
import { multiply } from '~/assets/js/utils.js'
import wikiSelect from '~/components/common/wikiSelect.vue'
export default {
  components: {
    barCharts,
    wikiSelect,
    mobileTab
  },
  data () {
    return {
      select: { value: 17, label: 'TYY_000748' },
      optionList: [
        { value: 17, label: 'TYY_000748' },
        { value: 50, label: 'TYY_000749' },
        { value: 100, label: 'TYY_000184' },
        { value: 200, label: 'TYY_000185' }
      ],
      lineSymbol: 'EURUSD', // 折线图当前品种
      tabName: [ // tab数据
        { name: 'EUR/USD', value: 'EURUSD', code: 0 },
        { name: 'GBP/USD', value: 'GBPUSD', code: 1 },
        { name: 'AUD/USD', value: 'AUDUSD', code: 2 },
        { name: 'USD/JPY', value: 'USDJPY', code: 3 },
        { name: 'USD/CAD', value: 'USDCAD', code: 4 },
        { name: 'NZD/USD', value: 'NZDUSD', code: 5 },
        { name: 'USD/CHF', value: 'USDCHF', code: 6 },
        { name: 'XAU/USD', value: 'XAUUSD', code: 7 },
        { name: 'EUR/AUD', value: 'EURAUD', code: 8 },
        { name: 'GBP/JPY', value: 'GBPJPY', code: 9 }
      ],
      // 持仓分布——下拉选择列表

      tabsIndex: 0, // 当前选中的tab下标
      tabsData: [ // tab数据
        { name: 'TYY_000655' },
        { name: 'TYY_000183' },
        { name: 'TYY_000182' },
        { name: 'TYY_000185' },
        { name: 'TYY_000110' }
      ],

      MoreEmptyRateData: []
    }
  },
  computed: {
    currencyOptionList () {
      return [
        { label: 'EUR/USD', value: 'EURUSD' },
        { label: 'GBP/USD', value: 'GBPUSD' },
        { label: 'AUD/USD', value: 'AUDUSD' },
        { label: 'NZD/USD', value: 'USDJPY' },
        { label: 'USD/JPY', value: 'USDCAD' },
        { label: 'USD/CAD', value: 'NZDUSD' },
        { label: 'USD/CHF', value: 'USDCHF' },
        { label: 'XAU/USD', value: 'XAUUSD' },
        { label: 'EUR/AUD', value: 'EURAUD' },
        { label: 'GBP/JPY', value: 'GBPJPY' }
      ]
    }
  },
  created () {
    this.selectVal = this.currencyOptionList[0]?.value || ''
  },
  mounted () {
    this.getLongShortRate(this.selectVal, this.select.value)
  },
  methods: {
    // 切换周期
    changeOption (e) {
      Object.assign(this.select, e)
      this.getLongShortRate(this.selectVal, this.select.value)
    },
    mobileTab ({ index }) {
      this.lineSymbol = this.tabName[index].value
      this.getLongShortRate(this.tabName[index].value, this.select.value)
    },
    // 切换symbol
    changeSymbol (value = '') {
      this.getLongShortRate(value, this.select.value)
    },
    // 获取历史多空占比
    async getLongShortRate (symbol, period) {
      try {
        const res = await this.$api.holdPosi.emotionDetailClient({ symbol, tradeType: 2 })
        this.MoreEmptyRateData = res.MoreEmptyRateTrendResponse?.MoreEmptyRateData?.slice(0, period)
        this.MoreEmptyRateData?.reverse()?.forEach((item) => {
          item.data1 = multiply(item.rate, 100)
          item.data2 = multiply(1 - item.rate, 100)
        })
      } catch (err) {}
    }

  }
}
